import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import {
	StyledContainer,
	StyledSectionContainer,
	StyledTitle,
} from '../../common';
import PricePreviewChangesTables from '../PricePreviewChangesTables';

interface Props {
	authData: AuthData;
	cancellationData: CancellationData;
}

const ReinstatementPricePreview = (props: Props) => {
	const { cancellationData } = props;

	const { policy, productConfig, selectedCancellation } = cancellationData;
	const priceData = selectedCancellation.reinstatement.price;

	const renderPriceTables = () => {
		return (
			<PricePreviewChangesTables
				productConfig={productConfig}
				priceData={priceData}
				policy={policy}
			/>
		);
	};

	return (
		<>
			<StyledContainer>
				<StyledTitle>Pricing Breakdown</StyledTitle>
			</StyledContainer>
			<hr />
			<StyledSectionContainer>{renderPriceTables()}</StyledSectionContainer>
		</>
	);
};

export default withCancellationContext<Props>(ReinstatementPricePreview);
